import * as CL from '@design-system/component-library';
import classNames from 'classnames';
import { dsClass } from '../../../../common/constants/dsClasses';
import { cancelMsg, t } from '../../../../common/i18n';
import { Modal } from '../../../Modal/Modal';

import './ConfirmModal.scss';

export interface ConfirmModalProps {
  onStay: () => void;
  onContinue: () => void;
}

export const ConfirmModal = ({ onStay, onContinue }: ConfirmModalProps) => (
  <Modal heading={t.YYZC('Do you want to continue without saving?')} closeable={false} size="m">
    <div>
      <p>{t.JBEE('The information you have entered will be lost if you continue without saving.')}</p>
      <div className={classNames('of-confirm-modal', dsClass.JUSTIFY_CONTENT_FLEX_END)}>
        <CL.Button className={classNames(dsClass.MARGIN_RIGHT_2)} color="secondary" onClick={onStay}>
          {t.B2V1(cancelMsg)}
        </CL.Button>
        <CL.Button color="primary" onClick={onContinue}>
          {t.HWV3('Continue without saving')}
        </CL.Button>
      </div>
    </div>
  </Modal>
);
